import { ApiEndpoint } from 'controller/endpoint'

export const getEventKey = ({ codeUrl, language }: { codeUrl: string; language: string }) =>
  `${ApiEndpoint.event.components(codeUrl)}/${language}`
